import React, { useEffect, useState } from 'react';
import { Button, Chip, IconButton, Typography, useMediaQuery } from '@mui/material';
import { AddShoppingCart} from '@mui/icons-material';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate, useParams } from 'react-router-dom';
import DeleteIcon from '@mui/icons-material/Delete';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import styled from "styled-components";
import { Image } from 'cloudinary-react'
import { useDispatch, useSelector } from 'react-redux';
import { addToCart } from '../../../../features/slices/cartSlice';
import { useDeleteSmartphoneMutation, useGetCartQuery, useGetUserFavoritesQuery, useUpdateCartMutation, useUpdateFavoriteMutation, useUpdateSmartphoneMutation } from '../../../../features/fullApi'
import ConfirmDialog from '../../../Modals/ConfirmDialog';
import { useTheme } from '@mui/material/styles';
import toast from 'react-hot-toast';
import ConfirmStatusDialog from '../../../Modals/ConfirmStatusDialog';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import './smartphone.css'
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { addToFavorite, removeFromFavorite } from '../../../../features/slices/favoriteSlice';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { makeStyles } from '@mui/styles';
import ReactGA from "react-ga4";

const useStyles = makeStyles({
  addToCartBtn: {
  },
});

const Info = styled.div`
  opacity: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.5s ease;
  cursor: pointer;
`;

const Container = styled.div`
  flex: 1;
  margin: 5px;
  width: 200px;
  height: 450px;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  align-items: center;
  border:1px solid #ededed;
  justify-content: center;
  position: relative;
`;

const MobileContainer = styled.div`
  border-radius: 10px;
  maxHeight: 350px;
  padding: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border: 1px solid #ddd;
  margin: 0 10px;
  position: relative;
`;

const TabletContainer = styled.div`
  display: flex;
  flex: 1;
  margin: 5px;
  width: 450px;
  height: 250px;
  align-items: center;
  justify-content: center;
  background-color: #f5fbfd;
  position: relative;s23
  &:hover ${Info}{
    opacity: 1;
  }
`;

const Icon = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px;
  transition: all 0.5s ease;
  &:hover {
    background-color: #e9f5f5;
    transform: scale(1.1);
    cursor:pointer;
  }
`;

const Product = ({ product }) => {
  const navigate = useNavigate()
  const user = JSON.parse(localStorage.getItem('user'))
  const dispatch = useDispatch()

  const [updateCart] = useUpdateCartMutation()
  const [deleteProduct] = useDeleteSmartphoneMutation()

  const {data: cart, error: cartError, isLoading: cartIsLoading} = useGetCartQuery(user?._id);

  const [open, setOpen] = useState(false)

  const cartLs = useSelector(state => state.cart)
  const favoriteLs = useSelector(state => state.favorite)
  const theme = useTheme()

  const [openStatus, setOpenStatus] = useState(false)

  const isXs= useMediaQuery(theme.breakpoints.down('xs'));
  const isSm= useMediaQuery(theme.breakpoints.down('sm'));
  const isMd= useMediaQuery(theme.breakpoints.down('md'));

  const {data: favorite, error: favoriteError, isLoading: favoriteIsLoading} = useGetUserFavoritesQuery(user?._id);
  const [updateFavorite] = useUpdateFavoriteMutation()

  const [remove, setRemove] = useState(false)
  const [red, setRed] = useState(false)
  const [checked, setChecked] = useState(false)

  const fav = JSON.parse(localStorage.getItem("favoriteItems"))
  const currentFavProducts = JSON.parse(localStorage.getItem("favoriteItems"))

  useEffect(() => {
      currentFavProducts?.map(favoriteProd => {
        if(favoriteProd._id === product._id) {
          setRed(true)
        }
    })
    setChecked(true)
  }, [])
  


  const handleAddToFavorites = async (productz) => {
    if(user?.accessToken && favorite?._id) {
      let found = false
        let newProducts = []
        const currentProducts = JSON.parse(localStorage.getItem("favoriteItems"))
        currentProducts?.map(async product => {
          if(product._id === productz._id) {
            dispatch(removeFromFavorite(productz))
            found = true
          } else {
            newProducts.push({productId: product._id})
          }
        })
        
        if(found) {
          setRed(false)
        } else{
          setRed(true)
          dispatch(addToFavorite(productz))
          newProducts.push({productId: productz._id})
        }
        
       

        updateFavorite({_id: favorite._id, products: newProducts}, { 
          headers: {
            'Token': `Bearer ${user?.accessToken}`
          }
        })
        .then(res => {
          console.log("res.data", res.data)
          if(!found) {
            toast.success('Product added to favorites')
          } else {
            toast('Product removed from favorites', {
              icon: '❌',
            });
          }
         
        })
        .catch(err => console.log("err", err))   
    } else {
      toast.error("Please log in or register", {
        position: "bottom-left",
    })
    }
  }

  const handleAddToCart = (product) => { 
    ReactGA.event({
      category: "chargers",
      action: "add to cart",
      label: product.title, 
    });
    if(user?.accessToken && cart?._id) {
      let cartProduct = cartLs.cartItems.filter(function (el)
      {
        return el._id === product._id
      })

      if(cartProduct.length === 0) {
        let newProducts = []
        dispatch(addToCart(product))
        const currentProducts = JSON.parse(localStorage.getItem("cartItems"))
        currentProducts.map(product => {
          newProducts.push({productId: product._id, quantity: product.cartQuantity})
        })
        console.log("Cart id", cart._id)
        console.log('products are', newProducts)
        updateCart({_id: cart._id, products: newProducts}, { 
          headers: {
            'Token': `Bearer ${user?.accessToken}`
          }
        })
        .then(res => {
          console.log("res.data", res.data)
          toast.success('Product added to cart')
        })
        .catch(err => console.log("err", err))
      } else if(cartProduct[0].cartQuantity < product.quantity) {
        let newProducts = []
        dispatch(addToCart(product))
        const currentProducts = JSON.parse(localStorage.getItem("cartItems"))
        currentProducts.map(product => {
          newProducts.push({productId: product._id, quantity: product.cartQuantity})
        })
        console.log("Cart id", cart._id)
        updateCart({_id: cart._id, products: newProducts}, { 
          headers: {
            'Token': `Bearer ${user?.accessToken}`
          }
        })
        .then(res => toast.success('Product added to cart'))
        .catch(err => console.log("err", err))
      } else {
        toast("You hitted our max stock for this product")
      }
    } else {
      toast.error("Please log in or register", {
        position: "bottom-left",
    })
    }
  }

  const openDeleteModal = ((productId) => {
    setOpen(true)
  })

  const handleDelete = ((productId) => {
    setOpen(false)
    console.log("product id is", productId)
    deleteProduct({id: productId}, { 
      headers: {
        'Token': `Bearer ${user?.accessToken}`
      }
    })
    toast.success("Product successfully deleted")
  })

  const [updateProduct] = useUpdateSmartphoneMutation()
  const handleToggleStatus = ((product) => {
    console.log("product SENT IS", product)
    setOpenStatus(false);
    updateProduct({_id: product._id, isActive: !product.isActive}, { 
      headers: {
        'Token': `Bearer ${product?.accessToken}`
      }
    }).then(res =>
        {
            if(res.data.isActive) {
              toast(`🟢 ${product.title} sent to shop`)
            } else {
              toast(`🚫 ${product.title} retreated from shop`)
            }
           
        }
    )
  })
  const openToggleStatusModal = (() => {
    console.log("product data", product)
    if(product.quantity > 0 && product.price !== 0) {
        setOpenStatus(true)
    } else {
        if(product.isActive) {
          setOpenStatus(true)
        }
        toast("⚠️ You must set price and quantity in order to toggle status")
    }
  
  })

  const classes = useStyles();
  const message = "Are you sure you want to delete this product ?";

  const renderMobileProduct = () => (
    <MobileContainer>
    {cartIsLoading && !user && !cartError ? (
          <></>
      ) :
      <div>
          <div style={{position:'absolute', right:'2px', top:'0px', backgroundColor:'transparent'}}>
            <Icon color={red ? "primary" : "#000"} style={{width:'40px', height:'40px',backgroundColor:'#efefef'}} onClick={() => handleAddToFavorites(product)}>
              {red ? <FavoriteIcon color="primary"/> : <FavoriteBorderIcon/>}
            </Icon>
          </div>
          <div style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
            <Image cloudName="deqqgmfxk"  publicId={product.img} style={{width: '140px', height: '140px', objectFit:'cover', objectPosition:'center', marginBottom: '15px'}}  onClick={() => navigate(`/smartphone/${product._id}`)}/>
          </div>
          <div style={{display: 'flex', flexDirection:'column', justifyContent: 'center', alignItems: 'center'}}>
            <Typography  onClick={() => navigate(`/smartphone/${product._id}`)} gutterBottom variant="subtitle1" component="h6" style={{textAlign: 'center'}}>
                {product.title}
            </Typography>
            <Typography  onClick={() => navigate(`/smartphone/${product._id}`)} gutterBottom variant="subtitle1" component="h6">
                ${product.price}
            </Typography>
            {(product.quantity <= 5 && product.quantity >=1) && <Chip style={{color: '#fff', backgroundColor: 'red', marginBottom: '5px'}} label={`${product.quantity} left`} />}
            {(product.quantity > 5) && <Chip style={{color: '#fff', backgroundColor: 'green', marginBottom: '5px'}} label={`5+ stock`} />}
            {(product.quantity === 0) && <Chip style={{color: '#fff', backgroundColor: '#eee', marginBottom: '5px'}} label={`0 left`} />}
            <Button disabled={product.quantity === 0} className={classes.addToCartBtn}  variant="contained" size="small" style={{width: '125px'}}  onClick={() => handleAddToCart(product)}>{product.quantity > 0 ? "Add to cart" : "Out of stock"}</Button>
            {user?.isAdmin &&
            <div style={{display: 'flex', justifyContent:'center', alignItems:'center', width:'50px'}}>
             <Icon fontSize="small" aria-label="Edit product" onClick={() => navigate(`/smartphone/edit/${product._id}`)}>
                <EditIcon/>
              </Icon>
              <Icon aria-label="Delete product" fontSize="small"  onClick={() => openDeleteModal()}>
                <DeleteIcon style={{color: 'red'}}/>
              </Icon>
              <Icon fontSize="small"  aria-label="Change Status" onClick={() => openToggleStatusModal(product._id)} size="small">
                  {product.isActive ?  <ToggleOnIcon style={{color: 'green'}}/> : <ToggleOffIcon style={{color: 'red'}}></ToggleOffIcon>}  
              </Icon>
              <ConfirmDialog open={open} handleDelete={handleDelete} setOpen={setOpen} item={product} message={message}></ConfirmDialog>
              <ConfirmStatusDialog openStatus={openStatus} handleToggleStatus={handleToggleStatus} setOpenStatus={setOpenStatus} item={product}></ConfirmStatusDialog>
            </div>
          }
        </div>
      </div>
  }
    </MobileContainer>
  )


  const renderTabletProduct = () => (
    <TabletContainer>
    {cartIsLoading && !user && !cartError ? (
          <></>
      ) :
      <>
        <Image cloudName="deqqgmfxk"  publicId={product.img} style={{width: '250px', height: '250px', objectFit:'cover', objectPosition:'center'}}/>
        <div style={{display: 'flex', flexDirection:'column', justifyContent: 'center', alignItems: 'center', padding: '10px', width: '200px'}} onClick={() => navigate(`/smartphone/${product._id}`)}>
        <Typography gutterBottom variant="h5" component="h2" style={{textAlign: 'center'}}>
            {product.title}
        </Typography>
        <Typography gutterBottom variant="h5" component="h2">
            ${product.price}
        </Typography>
        {(product.quantity <= 5 && product.quantity >=1) && <Chip style={{color: '#fff', backgroundColor: 'red', marginBottom: '5px'}} label={`${product.quantity} left`} />}
        {(product.quantity > 5) && <Chip style={{color: '#fff', backgroundColor: 'green', marginBottom: '5px'}} label={`5+ stock`} />}
        {(product.quantity === 0) && <Chip style={{color: '#fff', backgroundColor: '#eee', marginBottom: '5px'}} label={`0 left`} />}
        <Button  disabled={product.quantity === 0} className={classes.addToCartBtn}  variant="contained" size="small" style={{width: '125px'}}  onClick={() => handleAddToCart(product)}>{product.quantity > 0 ? "Add to cart" : "Out of stock"}</Button>
        </div>
      <Info>
        <IconButton disabled={product.quantity === 0} aria-label="Add to Cart" onClick={() => 
        {
          handleAddToCart(product);
        }}>
          <AddShoppingCart/>
        </IconButton>
        {user?.isAdmin && 
            <>
             <Icon aria-label="Edit product" onClick={() => navigate(`/smartphone/edit/${product._id}`)}>
                <EditIcon/>
              </Icon>
              <Icon aria-label="Delete product" onClick={() => openDeleteModal()}>
                <DeleteIcon style={{color: 'red'}}/>
              </Icon>
              <ConfirmDialog open={open} handleDelete={handleDelete} setOpen={setOpen} item={product} message={message}></ConfirmDialog>
            </>
        }

        <Icon aria-label="View product" onClick={() => navigate(`/smartphone/${product._id}`)}>
          <RemoveRedEyeIcon/>
        </Icon>
      </Info>
      </>
  }
    </TabletContainer>
  )

  const [title, setTitle] = useState(product.title)


  const renderDesktopProduct = () => (
    <Container sx={{padding: '10px', borderRadius: '10px'}}>
    {cartIsLoading && !user && !cartError && title && favoriteIsLoading && checked ? (
          <></>
      ) :
      <>
      <div style={{position:'absolute', right:'2px', top:'0px', backgroundColor:'transparent'}}>
      <Icon color={red ? "primary" : "#000"} style={{width:'40px', height:'40px',backgroundColor:'#efefef'}} onClick={() => handleAddToFavorites(product)}aria-label="Edit product">
        {red ? <FavoriteIcon color="primary"/> : <FavoriteBorderIcon/>}
      </Icon>
      </div>
      <div id="prodHover" className="productCard" onClick={() => navigate(`/smartphone/${product._id}`)}>
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <Image cloudName="deqqgmfxk"  publicId={product.img} style={{width: '175px', borderRadius: '10px', textAlign: 'center', height: '175px', objectFit:'cover', objectPosition:'center', margin: '0 auto'}}/>
        </div>
        
          <Typography gutterBottom variant="subtitle1" component="h6">
            {title?.substring(0, 30) + "..."}
          </Typography>
          <Typography gutterBottom variant="subtitle1" component="h6">
              ${product.price}
          </Typography>
          {(product.quantity <= 5 && product.quantity >=1) && <Chip style={{color: '#fff', backgroundColor: 'red', marginBottom: '5px'}} label={`${product.quantity} left`} />}
          {(product.quantity > 5) && <Chip style={{color: '#fff', backgroundColor: 'green', marginBottom: '5px'}} label={`5+ stock`} />}
          {(product.quantity === 0) && <Chip style={{color: '#fff', backgroundColor: '#eee', marginBottom: '5px'}} label={`0 left`} />}
      </div>

      <Button disabled={product.quantity === 0} className={classes.addToCartBtn}   variant="contained" size="small" style={{width: '125px', marginTop:'25px'}}  onClick={() => handleAddToCart(product)}>{product.quantity > 0 ? "Add to cart" : "Out of stock"}</Button>
      {user?.isAdmin && 
            <div style={{display:'flex', justifyContent:'space-between', alignItems:"center"}}>
             <Icon aria-label="Edit product" onClick={() => navigate(`/smartphone/edit/${product._id}`)}>
                <EditIcon/>
              </Icon>
              <Icon aria-label="Delete product" onClick={() => openDeleteModal()}>
                <DeleteIcon style={{color: 'red'}}/>
              </Icon>
              <Button aria-label="Change Status" className="addToCartBtn" onClick={() => openToggleStatusModal(product._id)} size="small">
                  {product.isActive ?  <ToggleOnIcon style={{color: 'green'}}/> : <ToggleOffIcon style={{color: 'red'}}></ToggleOffIcon>}  
              </Button>
              <ConfirmStatusDialog openStatus={openStatus} handleToggleStatus={handleToggleStatus} setOpenStatus={setOpenStatus} item={product}></ConfirmStatusDialog>
              <ConfirmDialog open={open} handleDelete={handleDelete} setOpen={setOpen} item={product} message={message}></ConfirmDialog>
            </div>
        }
      </>
  }
    </Container>
  )

  return (
    <div className="productClick">
        {
        (isXs) ?  renderMobileProduct() : 
        (isSm) ? renderMobileProduct() :
        (isMd) ? renderTabletProduct() :
        renderDesktopProduct()
      }
    </div>
  );
};

// const Product = connectHitInsights(aa)(ProductCard)
export default Product;